import { createContext, useContext, useState } from "react";
import environment from "../environment";


interface ICaptchaContextProps {
    captchaKey: string;
    captchaVerificado: boolean;
    setCaptchaVerificado: (isVerificado: boolean) => void;
}

const CaptchaContext = createContext<ICaptchaContextProps>({} as ICaptchaContextProps);

export function CaptchaContextProvider({ children }) {
    const [captchaVerificado, setCaptchaVerificado] = useState(false);
    const keyLocalhost = '6LcTv6waAAAAAOZNETjLA9YLnrZ0dyszBEAvirRZ';
    const key = '6LcGP6YhAAAAAJYcMYSBkx1iTA1eaWfmq_YU8-b9';
    const captchaKey = environment.ambiente == 'LOCAL' ? keyLocalhost : key;
    //const captchaKey = keyLocalhost;

    return (
        <CaptchaContext.Provider
            value={{
                captchaKey,
                captchaVerificado,
                setCaptchaVerificado
            }}
        >
            {children}
        </CaptchaContext.Provider>
    )
}

export const useCaptchaContext = () => {
    return useContext(CaptchaContext);
}